var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 20.14,
    viewBox: "0 0 24.001 20.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.915,4.752,20.3,21.808c-.25,1.21-.98,1.5-2,.94l-5.5-4.072L10.14,21.248a1.4,1.4,0,0,1-1.1.56c-.72,0-.6-.27-.84-.95L6.3,14.666l-5.452-1.7c-1.18-.35-1.19-1.16.26-1.751l21.268-8.2c.97-.43,1.9.24,1.531,1.731Z",
    transform: "translate(0.013 -2.883)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.eae26035a42f1f99baab5047444a8688.svg";
export { ForwardRef as ReactComponent };